import SXMLink from '@/shared-components/SXMLink';
import NoGames from './NoGames';

export interface ScheduleReminderProps {
    logo?: AEMImage;
    title?: string;
    url?: string;
}

export function ScheduleReminder({ logo, title, url }: ScheduleReminderProps) {
    if (!url) return undefined;

    return (
        <NoGames logo={logo} logoSize="small" title={title || 'Never Miss a Moment'}>
            <SXMLink href={url} dataCy="contextualcomponent-league-addtocal-link">
                Add to calendar
            </SXMLink>
        </NoGames>
    );
}
